export function getKeyCount(key, arr) {
  let num = 0
  arr.map(function (val) {
    if (val === key) {
      num ++
    }
  })
  return num
}



// WEBPACK FOOTER //
// ./src/lib/arrayHandle.js